export function formatDate(timestamp) {
	const dateObj = new Date(timestamp);
	const dateString = String(dateObj.getDate()).padStart(2, '0');
	const monthString = String(dateObj.getMonth() + 1).padStart(2, '0');

	return `${dateString}/${monthString}/${dateObj.getFullYear()}`;
}

export function formatDateTime(timestamp) {
	const dateObj = new Date(timestamp);
	const dateString = String(dateObj.getDate()).padStart(2, '0');
	const monthString = String(dateObj.getMonth() + 1).padStart(2, '0');
	const hours = String(dateObj.getHours()).padStart(2, '0');
	const minutes = String(dateObj.getMinutes()).padStart(2, '0');

	return `${dateString}/${monthString}/${dateObj.getFullYear()} ${hours}:${minutes}`;
}

export function isNull(value) {
	return value === null;
}
